import { render } from "./DocumentForm.vue?vue&type=template&id=42a66704&scoped=true&ts=true"
import script from "./DocumentForm.ts?vue&type=script&lang=ts"
export * from "./DocumentForm.ts?vue&type=script&lang=ts"

import "./DocumentForm.scss?vue&type=style&index=0&id=42a66704&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a66704"]])

export default __exports__